import { render } from "./TemplateDetail.vue?vue&type=template&id=7afaccb6&scoped=true"
import script from "./TemplateDetail.vue?vue&type=script&lang=js"
export * from "./TemplateDetail.vue?vue&type=script&lang=js"

import "./TemplateDetail.vue?vue&type=style&index=0&id=7afaccb6&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afaccb6"]])

export default __exports__